module.exports = __webpack_public_path__ + "img/sectionDelete.47715831.svg";